import script from "./OperationLogManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationLogManagement.vue?vue&type=script&setup=true&lang=js"

import "./OperationLogManagement.vue?vue&type=style&index=0&id=4f0b5074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0b5074"]])

export default __exports__